import styled from 'styled-components'
import { Picture } from '@ucheba/ui/components/Picture'
import { sv } from '@ucheba/utils/helpers/styles/variables'

export const ListItem = styled.div<{ isDivider: boolean }>`
  padding: ${sv.spacing.large} 0;

  border-top: 1px solid ${({ isDivider }) => (isDivider ? sv.color.gray9 : 'none')};
`

export const ListItemTouch = styled(ListItem)`
  &:last-of-type {
    padding-bottom: 24px;
  }
`

export const LogoDesktop = styled(Picture)`
  max-width: 64px;
  max-height: 80px;
`

export const LogoTouch = styled(Picture)`
  max-width: 120px;
  max-height: 56px;
`
